import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import {
  ICreateAgendamento,
  IEditAgendamento
} from 'src/app/services/AgendamentoService/agendamento.model';

import { FormAgendamentoHandler } from '../../../(Empresa)/agendamento/cadastro-agendamento/utils/form-agendamento-handlers';

@Component({
  selector: 'app-cadastro-agendamento',
  templateUrl: './cadastro-agendamento.component.html',
  styleUrls: ['./cadastro-agendamento.component.scss']
})
export class CadastroAgendamentoComponent
  extends FormAgendamentoHandler
  implements OnInit, OnDestroy
{
  constructor() {
    super();
    this.form = this._inicializarFormulario();
  }

  private _inicializarFormulario(): FormGroup {
    return this.fb.group({
      FK_SRVC: [0, [Validators.required]],
      DT_AGND: ['', [Validators.required]],
      FK_MTRT_EPSA: [0, [Validators.required]],
      NM_MTRT: [''],
      FK_CAVA: [0, [Validators.required]],
      FK_CRRT_1: [0],
      FK_CRRT_2: [0],
      FK_CRRT_3: [0],
      TX_OBSV_AGND: [''],
      TX_NOTA_FISCAL: [null, [Validators.required]],
      NU_PESO_TON: [null, [Validators.required]],
      NU_VOLUME: [null, [Validators.required]],
      TURNO: [''],
      FK_JNLA: [null, [Validators.required]],
      FK_TPTD: [0, [Validators.required]],
      FK_CLNT: [0, [Validators.required]],
      FK_DTNR: [0, [Validators.required]],
      FK_CRGA: [0, [Validators.required]],
      FK_TIPO_CRRT: [0, [Validators.required]]
    });
  }

  ngOnInit(): void {
    const status = this.statusAgendamento();

    const observables = [
      this.getServico(status),
      this.getMotorista(status),
      this.getPlacaCavalo(status),
      this.getPlacaCarreta(status),
      this.getTransportadora(),
      this.getCliente(),
      this.getDestinatario(),
      this.getCarga(),
      this.getJanelas(),
      this.getTipoCarreta()
    ];

    forkJoin(observables).subscribe(() => {
      this.stateForms();
    });

    const nome = localStorage.getItem('nome');
    this.form.controls['NM_MTRT'].setValue(nome);
    this.form.controls['NM_MTRT'].disable();

    this.monitorarCamposAgendamento();
  }

  createPayload(): ICreateAgendamento | IEditAgendamento {
    return {
      DT_AGND: this.dataAgendamentoParaApi(
        this.form.controls['DT_AGND'].value
      ),
      NU_STTS_AGND: 1,
      FK_MTRT_EPSA: 0,
      FK_MTRT_EXTR: Number(localStorage.getItem('id')),
      FK_CAVA: Number(this.form.controls['FK_CAVA'].value),
      FK_CRRT_1: Number(this.form.controls['FK_CRRT_1'].value),
      FK_CRRT_2: Number(this.form.controls['FK_CRRT_2'].value),
      FK_CRRT_3: Number(this.form.controls['FK_CRRT_3'].value),
      TX_OBSV_AGND: String(this.form.controls['TX_OBSV_AGND'].value),
      TX_NOTA_FISCAL: String(this.form.controls['TX_NOTA_FISCAL'].value),
      NU_PESO_TON: Number(this.form.controls['NU_PESO_TON'].value),
      NU_VOLUME: Number(this.form.controls['NU_VOLUME'].value),
      FK_SRVC: Number(this.form.controls['FK_SRVC'].value),
      FK_JNLA: Number(this.form.controls['FK_JNLA'].value),
      FK_TPTD: Number(this.form.controls['FK_TPTD'].value),
      FK_CLNT: Number(this.form.controls['FK_CLNT'].value),
      FK_DTNR: Number(this.form.controls['FK_DTNR'].value),
      FK_CRGA: Number(this.form.controls['FK_CRGA'].value),
      FK_TIPO_CRRT: Number(this.form.controls['FK_TIPO_CRRT'].value)
    };
  }

  postarDados() {
    if (this.form.valid) {
      this.isLoading = true;

      let payload = this.createPayload();
      if (this.title.includes('Editar')) {
        payload = {
          ...this.createPayload(),
          FK_CMNH: this.idCaminhao
        };

        this.agendamentoService
          .EditarAgendamentoEmpresa(this.idAgendamento, payload)
          .subscribe(
            () => {
              this.router.navigate(['motorista-externo/listagem/agendamento']);
              this.isLoading = false;
            },
            () => {
              this.isLoading = false;
            }
          );
      } else if (
        this.title.includes('Cadastro') ||
        this.title.includes('Novo Agendamento')
      ) {
        this.agendamentoService
          .CreateAgendamentoEmpresa(payload, this.guid)
          .subscribe(
            response => {
              const queryParams = {
                PK_AGND: response.PK_AGND,
                VL_SRVC: this.valorServico
              };

              this.router.navigate(['motorista-externo/pagamento'], {
                queryParams: queryParams
              });

              this.isLoading = false;
            },
            () => {
              this.isLoading = false;
            }
          );
      }
    } else {
      this.swalAlert.showAlert(
        'Atenção',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
